import React from 'react';
import {testGeoResolver} from "../backend/nodelambda/GeoLambda";
import {testNodeConnector} from "../backend/connectors/NodeConnector";
import {testDistanceCalculator} from "../logic_tmp/DistanceCalculator";
import {testDataCache} from "../logic_tmp/storage/DataCache";
import {testProfileLogic} from "../logic_tmp/storage/LgProfile";
import {testUtmParser} from "../logic/setup/UtmParser";
import {
    testCalculateDefaultParams,
    testCalculateDefaultParamsCello,
    testParametersParser
} from "../logic/setup/ParametersParser";
import {testProductParamsParser} from "../logic/setup/ProdcutParamsParser";
import {testBeginRouterLogic} from "../components/toRemove/Begin";
import {testPricePageLogic} from "../components/price/PricePageLogic";
import {testLeadPageLogic} from "../components/lead/LeadPageLogic";
import {testLeadGen} from "../functionaltests/TestLeadGen";
import {testLgStartLogic} from "../components/lg/LgStart";
import {testLgParamsParser} from "../logic/setup/LgParamsParser";
import {testLgHelper, testWhereGenerationByRegion} from "../components/lg/widgets/common/LgHelper";
import {runAllAcceptanceTests} from "../functionaltests/AcceptanceTests";
import {testPriceCalculator, testSpecialProposalRedim} from "../logic/setup/PriceCalculator";
import {testConfigLambda} from "../backend/LgSetup";
import {testLrrhLogic} from "../components/Lrrh/LrrhTests";


export async function runUnitTests() {
    let start = new Date().valueOf()
    //await testSpecialProposalRedim()
    //await runTests()
    const date = new Date();
    const options = {hour: 'short'}
    console.log("Tests...OK " + (date.valueOf() - start) + " ms. " + date.toLocaleTimeString(options))
}

async function runTests() {
    await testCalculateDefaultParamsCello()
    await testCalculateDefaultParams()
    await testLrrhLogic()
    // ----
    await testLgHelper()


    await testConfigLambda()
    await testUtmParser()
    await testParametersParser()

    await testLgParamsParser()
    await testProductParamsParser()
    await testGeoResolver()
    await testNodeConnector()
    await testDataCache()
    await testDistanceCalculator()
    await testProfileLogic()
    // Functional Tests
    await testLeadGen()
    await testPriceCalculator()
    //Pages Tests
    await testBeginRouterLogic()
    await testPricePageLogic()
    await testLeadPageLogic()
    await testLgStartLogic()
    //Acceptance tests
    await runAllAcceptanceTests()
    await testWhereGenerationByRegion()
}
